module.exports = __webpack_public_path__ + "img/tpc-23.ba38ae0e.jpg";